// jshint ignore: start

export default {
  "notificationsPopover": {
    "title": "Уведомления CGTrader AI",
    "indicator": {
      "lead": "Вы увидите",
      "highlight": "индикатор в верхнем меню",
      "rest": "во время генерации модели и когда она будет готова."
    },
    "emailToggle": "Отправить мне письмо, когда модель будет готова",
    "browserToggle": "Включить уведомления браузера",
    "note": "Мы уведомим вас, только если вы ещё не просмотрели элемент в CGTrader AI. Вы можете изменить настройки в любой момент в настройках AI.",
    "save": "Сохранить настройки",
    "close": "Закрыть"
  },
  "settingsModal": {
    "title": "Настройки",
    "tabs": {
      "usage": "Расход",
      "notifications": "Уведомления"
    },
    "notificationsTitle": "Уведомления CGTrader AI"
  },
  "seo": {
    "imagesTitle": "ИИ-изображения, созданные сообществом | CGTrader AI",
    "indexTitle": "3D-генератор на базе ИИ | CGTrader",
    "galleryTitle": "ИИ 3D-модели, созданные сообществом | CGTrader AI",
    "outputTitle": "3D-модель {{name}} | CGTrader AI"
  },
  "waitlist": {
    "card": {
      "chip": "Бесплатная бета",
      "freeGenerationsHighlight": "5 бесплатных генераций",
      "freeGenerationsSuffix": " в CGTrader AI",
      "noCreditCard": "Кредитная карта не требуется",
      "gettingStarted": "Отлично подходит для начала работы и знакомства",
      "join": "Записаться в лист ожидания",
      "joining": "Запись...",
      "haveAccessCode": "У меня есть код доступа",
      "joinError": "Не удалось записаться в лист ожидания. Попробуйте ещё раз."
    },
    "accessCode": {
      "label": "Введите код для бесплатного бета-доступа",
      "placeholder": "Введите код",
      "apply": "Применить",
      "applying": "Применение...",
      "successMessage": "Настраиваем ваш доступ - мы сообщим, когда всё будет готово.",
      "invalidMessage": "Недействительный код доступа. Попробуйте ещё раз.",
      "errorMessage": "Не удалось проверить код доступа. Попробуйте ещё раз."
    },
    "subscriptionBullets": {
      "monthly": "{{monthlyModels}} генераций CGTrader AI или загрузок из Marketplace",
      "editEnhance": "Редактируйте и улучшайте свои или купленные 3D-модели",
      "engines": "Все лучшие ИИ-движки включены: Tripo, Hunyuan, Meshy",
      "allAdvancedFeatures": "Доступ ко всем расширенным функциям"
    }
  },
  "bestOnDesktop": {
    "title": "Лучше на компьютере",
    "description": "CGTrader AI разработан для больших экранов. Некоторые инструменты редактирования, настройки и 3D-превью могут отображаться некорректно на мобильных устройствах. Для наилучшего результата переключитесь на компьютер."
  },
  "mobileTabBar": {
    "tabs": {
      "generate": "Генерация",
      "viewer": "3D-модель",
      "enhance": "Улучшение"
    }
  },
  "sidebar": {
    "header": {
      "title": "CGTrader AI"
    },
    "linkNav": {
      "generate": "Генератор 3D-моделей",
      "communityGallery": "Галерея сообщества",
      "imageGenerator": "Генератор изображений",
      "community": "Сообщество",
      "communityThreeDModels": "3D-модели",
      "communityImages": "Изображения"
    },
    "usage": {
      "label": "Расход"
    },
    "settings": {
      "label": "Настройки"
    },
    "termsOfService": {
      "label": "Условия использования"
    },
    "status": {
      "processing": "Обработка...",
      "generating": "Генерация..."
    },
    "actions": {
      "generateNewModel": "Сгенерировать новую 3D-модель"
    },
    "search": {
      "placeholder": "Поиск"
    },
    "filtering": {
      "generated": "Сгенерированные",
      "purchased": "Купленные",
      "uploaded": "Загруженные",
      "all": "Все",
      "favorites": "Избранное",
      "drafts": "Черновики"
    },
    "library": {
      "error": "Не удалось загрузить!",
      "emptyState": {
        "text": "Создайте свою первую 3D-модель, и ваша библиотека появится здесь",
        "imagesText": "Создайте изображения, и ваша библиотека появится здесь"
      },
      "notFound": {
        "text": "Ничего не найдено"
      },
      "tabs": {
        "models": "3D-модели",
        "images": "Изображения"
      }
    },
    "imageCard": {
      "notifications": {
        "deleteSuccess": "Изображение успешно удалено.",
        "deleteError": "Не удалось удалить изображение. Пожалуйста, попробуйте еще раз."
      }
    },
    "modelCard": {
      "draft": "Черновик",
      "makePrivate": "Сделать приватной",
      "created": "Создано: {{date}}",
      "delete": "Удалить",
      "variationsCount_0": "{{count}} вариация",
      "variationsCount_1": "{{count}} вариации",
      "variationsCount_2": "{{count}} вариаций"
    },
    "newModelCard": {
      "titleLine1": "Сгенерировать новую",
      "titleLine2": "3D-модель"
    },
    "useModelCard": {
      "titleLine1": "Своя",
      "titleLine2": "3D-модель"
    }
  },
  "imageAssistantPanel": {
    "errors": {
      "downloadFailed": "Не удалось скачать. Попробуйте еще раз."
    },
    "title": "ИИ-ассистент по изображениям",
    "actions": {
      "useForThreeDGeneration": "Использовать для 3D-генерации",
      "regenerate": "Перегенерировать",
      "editImage": "Редактировать",
      "modifyImage": "Изменить изображение",
      "download": "Скачать"
    },
    "createTab": {
      "composer": {
        "send": "Сгенерировать новое"
      },
      "newImageNote": "Новый запрос создаст новое изображение.",
      "conversation": {
        "emptyPrompt": "Что вы хотели бы создать?"
      },
      "result": {
        "expand": "Открыть изображение в полном размере",
        "lightbox": "Сгенерированное изображение"
      },
      "generatingState": {
        "label": "Создание вашего изображения..."
      },
      "failedState": {
        "title": "Генерация не удалась",
        "text": "При генерации вашего изображения что-то пошло не так. Пожалуйста, попробуйте еще раз.",
        "retry": "Сгенерировать снова"
      }
    },
    "editTab": {
      "back": "Назад",
      "composer": {
        "placeholder": "Опишите, что изменить (например, удалить фон, упростить детали)",
        "placeholderWithImageTools": "Опишите, что изменить (например, удалить фон, увеличить разрешение, скорректировать или упростить детали)"
      },
      "emptyState": {
        "title": "Чтобы отредактировать изображение, сначала загрузите, найдите или создайте его",
        "titleWithoutSearch": "Чтобы отредактировать изображение, сначала загрузите или создайте его",
        "subtitle": "Поддерживает текстовые инструкции и inpainting"
      },
      "toolbar": {
        "version": "Версия {{number}}",
        "originalVersion": "Оригинал",
        "history": "История",
        "removeBackground": "Удалить фон",
        "upscale": "Увеличить разрешение",
        "versionKind": {
          "brush": "Кисть",
          "prompt": "Запрос"
        }
      },
      "promptViewer": {
        "toggleLabel": "Показать запрос, использованный для этой версии",
        "copyLabel": "Копировать запрос",
        "copiedLabel": "Скопировано",
        "copiedNotification": "Запрос скопирован в буфер обмена"
      }
    },
    "searchTab": {
      "searchPlaceholder": "Поиск референсных изображений",
      "categoriesHeading": "Самые популярные категории изображений",
      "loading": "Загрузка результатов поиска...",
      "noResults": {
        "title": "Ничего не найдено",
        "subtitle": "Попробуйте создать референсное изображение по вашему запросу",
        "create": "Создать изображение"
      }
    }
  },
  "usageModal": {
    "header": {
      "unlockAiGeneration": "Разблокировать ИИ-генерацию",
      "betaAccessRequested": "Доступ к бете запрошен",
      "aiUsage": "Расход CGTrader AI"
    },
    "tags": {
      "freePlan": "Бесплатный план",
      "subscription": "Подписка CGTrader"
    },
    "setupHeadline": "Вы все настроили - теперь разблокируйте генерацию, чтобы воплотить это в жизнь.",
    "terms": {
      "leadDefault": "Продолжая использовать CGTrader AI, вы соглашаетесь с",
      "leadWaitlisted": "Продолжая, я соглашаюсь с",
      "tosLink": "Условиями использования CGTrader AI"
    },
    "extraUsage": {
      "titleWithPrice": "Получите еще {{count}} генераций за {{price}}",
      "title": "Получите еще {{count}} генераций",
      "subtitle": "Продолжайте творить без перерывов",
      "cta": "Купить дополнительное использование",
      "note": "Дополнительное использование не истекает и не сбрасывается ежемесячно."
    },
    "freeBeta": {
      "outOfGenerations": "У вас закончились бесплатные генерации",
      "almostOutOfGenerations": "У вас почти закончились бесплатные генерации",
      "generationsUsedLabel": "Использовано генераций"
    },
    "freeBetaCard": {
      "successMessage": "Все готово! Начните создавать свои 3D-модели.",
      "errorMessage": "Не удалось запустить бесплатную бету. Пожалуйста, попробуйте еще раз.",
      "chip": "Бесплатная бета",
      "freeGenerations": "5 бесплатных генераций",
      "inStudio": " в CGTrader AI Studio",
      "noCreditCard": "Кредитная карта не требуется",
      "gettingStarted": "Отлично подходит для начала и знакомства",
      "starting": "Запуск...",
      "cta": "Начать создавать бесплатно"
    },
    "hasCredits": {
      "creditsLeft_0": "У вас остался {{count}} кредит",
      "creditsLeft_1": "У вас осталось {{count}} кредита",
      "creditsLeft_2": "У вас осталось {{count}} кредитов"
    },
    "subscribed": {
      "outOfGenerations": "У вас закончились генерации",
      "monthlyGenerationsUsedLabel": "Использовано ежемесячных генераций",
      "generationsRatioTooltip": "10 генераций изображений равны 1 обычной 3D-генерации",
      "extraGenerationsUsedLabel": "Использовано дополнительных генераций",
      "resetDateLabel": "Дата сброса:",
      "subscriptionSettings": "Перейти к настройкам подписки"
    },
    "subscriptionCard": {
      "priceUnit": "/ месяц",
      "cta": "Оформить подписку"
    },
    "upgrade": {
      "title": "Улучшите план, чтобы начать создавать"
    },
    "upgradeCard": {
      "defaultTitle": "Улучшите план, чтобы продолжить создавать",
      "priceUnit": "/ месяц",
      "cta": "Оформить подписку"
    },
    "paidFeature": {
      "title": "Улучшите план, чтобы творить свободнее",
      "advancedFeaturesTitle": "Откройте расширенные функции:",
      "advancedFeatures": {
        "private": "Держите модели приватными, чтобы только вы могли просматривать их и делиться ими",
        "dccBridge": "Интеграция с DCC Bridge для бесшовного рабочего процесса",
        "export": "Экспортируйте модели в любом поддерживаемом формате",
        "multipleModels": "Генерируйте несколько моделей одновременно"
      }
    },
    "waitlisted": {
      "onWaitlist": "Вы в списке ожидания!",
      "copy": "Мы рассмотрим ваш запрос и уведомим вас по электронной почте, как только доступ станет доступен.",
      "accessCode": "У меня есть код доступа",
      "upgradeTitle": "Быстрый доступ с подпиской"
    }
  },
  "viewerSidebar": {
    "nav": {
      "enhance3dModel": "Улучшить 3D-модель",
      "remesh": "Ремешинг",
      "texture": "Текстура",
      "segment": "Сегментация",
      "animate": "Анимация",
      "render": "Рендер",
      "variations": "Вариации",
      "assist": "Помощь",
      "disabledReason": "Сгенерируйте или загрузите модель, чтобы начать ее редактирование",
      "variationsNotOwnerReason": "Вариации доступны только для ваших собственных моделей"
    },
    "enhance": {
      "common": {
        "done": "Готово",
        "processing": "Обработка..."
      },
      "remesh": {
        "title": "Ремешинг",
        "generateLabel": "Ремешинг",
        "smartLowPoly": "Умный low poly",
        "polycount": {
          "label": "Количество полигонов",
          "low": "Низкое",
          "medium": "Среднее",
          "high": "Высокое"
        },
        "example": {
          "highPoly": "High-poly сетка",
          "optimized": "Оптимальная сетка"
        }
      },
      "texture": {
        "title": "Текстура",
        "generateLabel": "Сгенерировать текстуру",
        "textPlaceholder": "Опишите текстуру, которую хотите сгенерировать для этой модели",
        "material": {
          "label": "Материал",
          "pbr": "PBR",
          "basic": "Базовый материал"
        },
        "resolution": {
          "label": "Разрешение",
          "2k": "2K",
          "4k": "4K",
          "8k": "8K"
        },
        "preview": {
          "initial": "Исходная текстура",
          "new": "Новая текстура"
        }
      },
      "segment": {
        "title": "Сегментация",
        "riggedTooltip": "Сегментация недоступна для моделей с ригом.",
        "placeholderTitle": "Сегментация",
        "placeholderDescription": "Автоматически разделите вашу 3D-модель на редактируемые части",
        "explodedView": "Разнесенный вид",
        "resetModel": "Сбросить модель",
        "partList": "Список частей",
        "generateLabel": "Начать сегментацию",
        "generatingLabel": "Сегментация...",
        "unavailable": {
          "title": "Недоступно для",
          "quad": "Quad-моделей",
          "rigged": "Моделей с ригом"
        }
      },
      "animate": {
        "title": "Анимация",
        "description": "Анимируйте вашу 3D-модель с помощью интеллектуального управления движением",
        "rigDescription": "Создайте риг модели, чтобы анимировать её",
        "generateLabel": "Анимация",
        "searchPlaceholder": "Поиск анимации",
        "noResults": "Анимации не найдены"
      },
      "render": {
        "title": "Рендер 2D",
        "description": "Создавайте высококачественные рендеры вашей 3D-модели за секунды",
        "viewerHint": "Расположите 3D-модель в просмотрщике",
        "promptLabel": "Текстовый запрос",
        "promptPlaceholder": "Добавьте детали финального вида, например кинематографический свет, мягкие тени, студийный фон",
        "styleLabel": "Стиль",
        "styleNone": "Нет",
        "generateLabel": "Отрендерить изображение",
        "stylePanel": {
          "title": "Выберите стиль",
          "close": "Закрыть выбор стиля",
          "searchPlaceholder": "Поиск стиля",
          "categoriesLabel": "Категории стилей"
        }
      },
      "variations": {
        "title": "Вариации",
        "emptyState": "Улучшите или перегенерируйте вашу модель. Новые вариации появятся здесь.",
        "uploaded": "Загружено",
        "menu": {
          "created": "Создано: {{date}}",
          "setAsMain": "Сделать основной",
          "delete": "Удалить"
        },
        "notifications": {
          "setAsMainSuccess": "\"{{name}}\" успешно установлена как основная",
          "setAsMainError": "Не удалось установить вариацию как основную. Пожалуйста, попробуйте еще раз.",
          "deleteSuccess": "\"{{name}}\" успешно удалена",
          "deleteError": "Не удалось удалить вариацию. Пожалуйста, попробуйте еще раз."
        }
      },
      "assist": {
        "heading": "Запрос помощи дизайнера",
        "placeholderDescription": "Получите помощь от настоящего дизайнера, когда она вам понадобится",
        "form": {
          "title": {
            "label": "Название",
            "placeholder": "Введите здесь..."
          },
          "description": "Описание",
          "budget": "Бюджет",
          "resell": "Я разрешаю дизайнеру продавать результаты проекта на маркетплейсе",
          "terms": {
            "agree": "Я согласен с ",
            "link": "Условиями и положениями"
          },
          "submit": "Опубликовать проект",
          "loadSoftwareError": "Не удалось загрузить 3D-программное обеспечение",
          "submitError": "Что-то пошло не так, пожалуйста, попробуйте еще раз"
        },
        "deadline": {
          "label": "Срок",
          "noFixed": "Без фиксированного срока"
        },
        "software": {
          "label": "3D-программа",
          "placeholder": "Выберите 3D-программу"
        },
        "references": {
          "label": "Визуальные референсы",
          "note": "Мы поделимся исходными данными. Вы также можете добавить референсы.",
          "untitledModel": "Модель без названия",
          "dropzone": {
            "title": "Перетащите изображения сюда",
            "or": "или",
            "browse": "Выбрать"
          },
          "errors": {
            "uploadFailed": "Не удалось прикрепить ваш файл. Пожалуйста, попробуйте еще раз или обратитесь в нашу службу поддержки",
            "onlyImages": "Прикрепить можно только файлы изображений.",
            "tooBig": "Вложение слишком большое, постарайтесь не превышать 100 МБ.",
            "duplicate": "Нельзя прикрепить файл с таким же именем"
          }
        },
        "posted": {
          "title": "Запрос отправлен",
          "description": "Ваш проект опубликован в открытом списке для фрилансеров-дизайнеров. Вы получите уведомление, когда кто-то откликнется",
          "cta": "Перейти к моим 3D-проектам"
        }
      }
    }
  },
  "shared": {
    "aiEngine": {
      "label": "ИИ-движок",
      "disabledTooltip": "Недоступно для этой комбинации настроек"
    },
    "polyCount": {
      "label": "Количество полигонов",
      "low": "Низкое",
      "medium": "Среднее",
      "high": "Высокое"
    },
    "polygonType": {
      "label": "Тип полигонов",
      "quad": "Quad",
      "triangular": "Треугольные"
    },
    "placeholder": {
      "comingSoon": "Скоро"
    },
    "subscribersOnly": {
      "title": "Только для подписчиков",
      "simultaneousGenerationsTitle": "Несколько одновременных генераций доступны только подписчикам",
      "getSubscription": "Оформить подписку"
    },
    "uploadModel": {
      "uploading": "Загрузка...",
      "upload": "Использовать свою 3D-модель"
    },
    "shareContent": {
      "embedButtonLabel": "Встроить эту 3D-модель"
    },
    "generateButton": {
      "inProgressTooltip": "Сейчас выполняется другая генерация. Это действие станет доступным после ее завершения.",
      "limitReachedTooltip": "Вы достигли максимального количества активных генераций. Это действие станет доступным после завершения одной из них.",
      "sameSettingsTooltip": "Эта генерация уже выполняется. Измените любые настройки, чтобы запустить другую генерацию.",
      "genericError": "Не удалось выполнить генерацию. Попробуйте еще раз."
    },
    "privateMode": {
      "label": "Приватный режим",
      "tooltip": "В приватном режиме только вы можете просматривать и делиться моделью. Если приватный режим не включён, модель может отображаться в галерее сообщества, где другие пользователи могут просматривать и ремиксить её."
    },
    "actionSelector": {
      "tabs": {
        "singleImage": "Одно изображение",
        "multiView": "Мультивид",
        "multiViewTooltip": "Загрузите один и тот же объект с нескольких ракурсов, чтобы получить более точную 3D-модель. Вид спереди обязателен.",
        "image": "Изображение",
        "text": "Текст"
      },
      "textInstructions": {
        "maxCharacters": "Разрешено не более {{maxLength}} символов"
      },
      "imageUploader": {
        "multiView": {
          "required": "Обязательно",
          "title": "Загрузка изображений с нескольких ракурсов",
          "upload": "Загрузить изображение ракурса: {{view}}",
          "remove": "Удалить изображение ракурса: {{view}}",
          "preview": "Предпросмотр ракурса: {{view}}",
          "views": {
            "front": "Спереди",
            "left": "Слева",
            "right": "Справа",
            "back": "Сзади",
            "top": "Сверху",
            "bottom": "Снизу",
            "leftFront": "Спереди слева",
            "rightFront": "Спереди справа"
          }
        },
        "uploadPrompt": {
          "dropHere": "Перетащите изображение сюда или",
          "browse": "выберите",
          "fileTypes": "PNG, JPG, WEBP"
        },
        "pasteUrl": {
          "placeholder": "URL изображения",
          "upload": "Загрузить изображение"
        },
        "preview": {
          "edit": "Редактировать это изображение"
        },
        "ideation": {
          "search": "Найти изображение",
          "create": "Создать изображение",
          "edit": "Редактировать изображение"
        }
      }
    },
    "composer": {
      "placeholder": "Опишите объект и ракурс (например, электрический спорткар, вид спереди 3/4)"
    },
    "dccNotification": {
      "connecting": "Подключение плагина...",
      "sending": "Отправка 3D-модели в {{name}}...",
      "success": "3D-модель отправлена в {{name}}",
      "pluginNotRunning": {
        "title": "Плагин не запущен",
        "descriptionWithName": "Убедитесь, что ваш DCC открыт, а плагин для {{name}} установлен и запущен.",
        "description": "Убедитесь, что ваш DCC открыт, а плагин установлен и запущен."
      },
      "dccBusy": {
        "title": "DCC занят",
        "description": "Он все еще обрабатывает предыдущий импорт. Повторите попытку через мгновение."
      },
      "error": {
        "title": "Что-то пошло не так",
        "description": "Возникла проблема при отправке вашей модели. Попробуйте еще раз."
      }
    },
    "deleteConfirmModal": {
      "header": "Удалить {{itemType}}?",
      "submit": "Удалить",
      "cancel": "Отмена",
      "bodyNamed": "\"{{itemName}}\" будет удален безвозвратно. Это действие нельзя отменить.",
      "bodyGeneric": "Этот {{itemType}} будет удален безвозвратно. Это действие нельзя отменить.",
      "itemTypes": {
        "item": "элемент",
        "model": "модель",
        "variation": "вариация",
        "comment": "комментарий",
        "reply": "ответ",
        "image": "изображение"
      }
    },
    "exportNotification": {
      "queued": {
        "title": "Файл добавлен в очередь.",
        "description": "Экспорт начнется в ближайшее время."
      },
      "preparing": {
        "title": "Подготовка файла к загрузке."
      },
      "error": {
        "title": "Что-то пошло не так",
        "description": "Не удалось завершить экспорт. Попробуйте еще раз."
      }
    }
  },
  "leftSide": {
    "generate": {
      "generate": "Сгенерировать 3D-модель",
      "regenerate": "Перегенерировать 3D-модель",
      "generated": "Сгенерировано",
      "generating": "Генерация..."
    },
    "modelSettings": {
      "promptPlaceholder": "Опишите, что вы хотите создать"
    },
    "useCase": {
      "title": "Сценарий использования",
      "options": {
        "standard": {
          "title": "Стандартный",
          "description": "Подходит для большинства случаев. Сбалансированное качество и количество полигонов с PBR-текстурами."
        },
        "hero": {
          "title": "Ключевой ассет",
          "description": "Максимальное качество. Плотная quad-сетка с полным PBR - идеально для премиум-ассетов."
        },
        "prop": {
          "title": "Реквизит",
          "description": "Готовый для игр реквизит со средним количеством полигонов."
        },
        "threeDPrint": {
          "title": "3D-печать",
          "description": "Плотная триангулированная сетка для 3D-печати с базовым материалом."
        },
        "shapeOnly": {
          "title": "Только форма",
          "description": "Плотная сетка без текстур. Идеально для проверки геометрии и детализации поверхности."
        },
        "lowPoly": {
          "title": "Low Poly",
          "description": "Сетка с низким количеством полигонов и PBR-текстурами."
        }
      }
    },
    "material": {
      "label": "Материал",
      "pbr": "PBR",
      "basic": "Базовый",
      "geometryOnly": "Только геометрия",
      "geometry": "Геометрия"
    },
    "extraQuality": {
      "label": "Повышенное качество",
      "badge": "Новое",
      "hint": "2x расход, дольше генерация"
    },
    "smartLowPoly": {
      "label": "Умный low poly",
      "collapsedLabel": "Low poly"
    },
    "advancedSettings": {
      "trigger": "Расширенные настройки"
    },
    "polyCount": {
      "label": "Количество полигонов",
      "low": "Низкое",
      "medium": "Среднее",
      "high": "Высокое"
    },
    "polygonType": {
      "label": "Тип полигонов",
      "quad": "Quad",
      "triangular": "Треугольные"
    },
    "aiEngine": {
      "label": "ИИ-движок"
    },
    "actionPreview": {
      "title": "Ввод"
    }
  },
  "header": {
    "modelSettings": "Сгенерировать 3D-модель",
    "viewer": "3D-модель"
  },
  "community": {
    "card": {
      "remix": "Ремикс {{title}}",
      "remixBy": "Ремикс {{title}} от {{username}}"
    }
  },
  "imageGallery": {
    "card": {
      "open": "Открыть {{title}}",
      "edit": "Редактировать {{title}}",
      "download": "Скачать {{title}}",
      "generate3d": "Создать 3D",
      "generate3dFor": "Создать 3D-модель из {{title}}"
    },
    "categories": {
      "all": "Все",
      "aircraft": "Авиация",
      "animals": "Животные",
      "architectural": "Архитектура",
      "exterior": "Экстерьер",
      "interior": "Интерьер",
      "car": "Автомобиль",
      "character": "Персонаж",
      "military": "Военное",
      "furniture": "Мебель",
      "food": "Еда",
      "plant": "Растения",
      "science": "Наука",
      "space": "Космос",
      "sports": "Спорт",
      "vehicle": "Транспорт",
      "watercraft": "Водный транспорт"
    },
    "modal": {
      "ariaLabel": "Изображение {{title}}",
      "previous": "Предыдущее изображение",
      "next": "Следующее изображение",
      "edit": "Редактировать",
      "download": "Скачать",
      "createdBy": "Создано {{username}}",
      "prompt": "Промпт",
      "copyPrompt": "Копировать промпт",
      "expandPrompt": "Показать весь промпт",
      "collapsePrompt": "Свернуть промпт",
      "generationSettings": "Настройки генерации",
      "settings": {
        "reference": "Референс",
        "baseModel": "Базовая модель",
        "aspectRatio": "Соотношение сторон",
        "style": "Стиль",
        "resolution": "Разрешение изображения",
        "seed": "Сид"
      },
      "similarImages": "Похожие изображения"
    },
    "downloadFailed": "Не удалось скачать. Попробуйте еще раз.",
    "loadError": "Не удалось загрузить изображения.",
    "searchPlaceholder": "Поиск",
    "moreCategories": "Ещё",
    "empty": {
      "title": "Изображения по вашим критериям не найдены",
      "description": "Попробуйте изменить запрос или выбрать другие фильтры",
      "clearFilters": "Сбросить фильтры"
    }
  },
  "commentsModal": {
    "ariaLabel": "Комментарии",
    "placeholder": "Поделитесь здесь своими мыслями.",
    "replyPlaceholder": "Напишите свой ответ здесь",
    "post": "Опубликовать",
    "reply": "Ответить",
    "delete": "Удалить",
    "deleteCommentBy": "Удалить комментарий пользователя {{username}}",
    "deleteReplyBy": "Удалить ответ пользователя {{username}}",
    "relativeTime": {
      "year": "{{count}} г",
      "month": "{{count}} мес",
      "week": "{{count}} нед",
      "day": "{{count}} д",
      "hour": "{{count}} ч",
      "minute": "{{count}} мин",
      "second": "{{count}} с"
    },
    "hide": "Скрыть",
    "creatorBadge": "Создатель модели",
    "commentsCount_0": "{{count}} комментарий",
    "commentsCount_1": "{{count}} комментария",
    "commentsCount_2": "{{count}} комментариев",
    "repliesCount_0": "{{count}} ответ",
    "repliesCount_1": "{{count}} ответа",
    "repliesCount_2": "{{count}} ответов",
    "empty": "Комментариев пока нет. Поделитесь своими мыслями первым.",
    "loadError": "Не удалось загрузить комментарии.",
    "submitError": "Что-то пошло не так. Пожалуйста, попробуйте ещё раз.",
    "limitReached": "Вы достигли лимита комментариев. Пожалуйста, попробуйте позже.",
    "loginPrompt": "Войдите, чтобы присоединиться к обсуждению.",
    "login": "Войти"
  },
  "like": {
    "likeModel": "Нравится {{title}}",
    "unlikeModel": "Убрать отметку «Нравится» у {{title}}",
    "like": "Нравится",
    "unlike": "Убрать отметку «Нравится»",
    "dailyLimitReached": "Вы достигли дневного лимита отметок «Нравится». Попробуйте снова завтра."
  },
  "likers": {
    "title_0": "{{count}} отметка «Нравится»",
    "title_1": "{{count}} отметки «Нравится»",
    "title_2": "{{count}} отметок «Нравится»",
    "openList": "Посмотреть, кому понравилась эта модель",
    "close": "Закрыть",
    "relativeTime": {
      "day": "{{count}} д назад",
      "hour": "{{count}} ч назад",
      "minute": "{{count}} мин назад",
      "second": "{{count}} с назад"
    }
  },
  "footerActions": {
    "delete": "Удалить",
    "share": "Поделиться",
    "creator": {
      "createdBy": "Автор: {{username}}"
    },
    "export": {
      "label": "Экспорт"
    },
    "dccBridge": {
      "tooltip": "Сначала установите и запустите плагин, чтобы отправлять модели в соответствующее DCC-программное обеспечение",
      "comingSoon": "Скоро",
      "downloadPluginButton": "Скачать плагин",
      "guide": "Руководство"
    },
    "sendTo": {
      "label": "Отправить в",
      "labelWithName": "Отправить в {{name}}",
      "needHelp": "Нужна помощь?",
      "setupGuide": "Смотреть руководство по настройке",
      "downloadPlugin": "Скачать плагин",
      "step1": "Скачайте и установите плагин",
      "step2": "Запустите ваше DCC и убедитесь, что плагин работает",
      "step3": "Отправьте вашу модель напрямую в ваше DCC."
    },
    "modelTitle": {
      "updateSuccess": "Название модели успешно обновлено.",
      "updateError": "Не удалось обновить название модели."
    }
  },
  "viewer": {
    "banner": {
      "phase": {
        "queued": "Ожидание в очереди...",
        "analyzing": "Анализ ваших данных...",
        "generating": "Генерация вашей 3D-модели...",
        "refining": "Доработка деталей...",
        "finalizing": "Завершение вашей 3D-модели..."
      },
      "phaseTimeLeft": {
        "minutes": "Осталось ~{{minutes}} мин",
        "lessThanMinute": "Осталось меньше 1 мин"
      },
      "slotsNotice": {
        "highlight": "{{available}} из {{total}} одновременных генераций",
        "rest": "всё ещё доступны в вашем тарифе. Продолжайте создавать и редактировать свои модели!"
      },
      "unlockFeatures": {
        "title": "Откройте расширенные функции",
        "cta": "Оформить подписку",
        "simultaneousGenerations": "До 5 генераций одновременно",
        "queuePriority": "Приоритет в очереди",
        "privateMode": "Приватный режим",
        "dccBridge": "DCC Bridge",
        "modelDownloads": "Загрузка 3D-моделей"
      },
      "initial": "Здесь появится ваша 3D-модель",
      "generatingTitle": "Генерация вашей 3D-модели",
      "generatingDescription": "Это может занять несколько минут. Вы увидите индикатор в верхнем меню, когда всё будет готово. Мы также отправим вам письмо, чтобы вы ничего не пропустили.",
      "loadingTitle": "Загрузка 3D-модели",
      "uploadingTitle": "Загрузка вашей 3D-модели...",
      "uploadingDescription": "Это может занять некоторое время. Сложные модели могут загружаться дольше.",
      "cleverPush": {
        "prompt": "Получайте уведомления, даже когда переключаете вкладки",
        "allow": "Разрешить уведомления браузера"
      },
      "relatedProducts": {
        "title": "Вам также может понравиться",
        "viewMore": "Смотреть больше на Маркетплейсе"
      }
    },
    "errorBanner": {
      "tryAgain": "{{action}} снова",
      "title": "Что-то пошло не так",
      "description": "Нам не удалось выполнить это действие. Попробуйте изменить настройки, упростить ввод или проверить референсы.",
      "errorId": "ID ОШИБКИ",
      "reason": "ПРИЧИНА",
      "message": "СООБЩЕНИЕ",
      "providerCode": "КОД ПРОВАЙДЕРА"
    },
    "modelReadyToaster": {
      "message": "Ваша модель готова! Теперь изучите инструменты улучшения, чтобы доработать и настроить её.",
      "dontShowAgain": "Больше не показывать"
    },
    "remixNotice": {
      "title": "Вы в режиме ремикса",
      "description": "Изменяйте настройки, перегенерируйте и улучшайте эту 3D-модель, чтобы создать свою версию. Новые творения будут сохранены в вашей библиотеке.",
      "tag": "Режим ремикса"
    },
    "termsOfServiceNotice": {
      "lead": "Обратите внимание: продолжая использовать CGTrader AI, вы соглашаетесь с",
      "link": "Условиями использования CGTrader AI"
    },
    "canvas": {
      "failedToStart": "Не удалось запустить"
    },
    "environment": {
      "title": "Настройки окружения",
      "strength": "Интенсивность",
      "rotation": "Поворот",
      "uploadHdri": "Загрузить HDRI",
      "surrounding": "Окружение",
      "showDefaultHdri": "Показать HDRI по умолчанию",
      "showHdri": "Показать HDRI",
      "uploadFailed": "Не удалось загрузить HDRI. Пожалуйста, попробуйте ещё раз.",
      "added": "\"{{label}}\" добавлено в окружение."
    },
    "sidebar": {
      "lighting": "Освещение (L)",
      "toggleGrid": "Переключить сетку (G)",
      "autoRotate": "Переключить автоповорот (R)",
      "resetCamera": "Сбросить камеру (F)"
    },
    "renderMode": {
      "pbr": "PBR (M)",
      "clay": "Глина (C to cycle)",
      "baseColor": "Только базовый цвет (C to cycle)",
      "roughness": "Только шероховатость (C to cycle)",
      "normals": "Только нормали (C to cycle)",
      "metalness": "Только металличность (C to cycle)",
      "segmentation": "Сегментация (C to cycle)",
      "wireframe": "Каркас (W)"
    },
    "animationPlayer": {
      "play": "Воспроизвести анимацию",
      "pause": "Приостановить анимацию",
      "timeline": "Шкала времени анимации",
      "progress": "{{current}} из {{total}}"
    },
    "modelDetails": {
      "faces": "Грани",
      "vertices": "Вершины",
      "aiEngine": "ИИ-движок",
      "extraQuality": "Экстра",
      "lowPoly": "Low poly",
      "polycount": "Количество полигонов",
      "polygonType": "Тип полигонов",
      "material": "Материал",
      "true": "Да",
      "false": "Нет",
      "materialBasic": "Базовый",
      "materialGeometryOnly": "Только геометрия"
    }
  },
  "signIn": {
    "header": {
      "signupTitle": "Создайте аккаунт, чтобы начать",
      "cgdreamSignupTitle": "Войдите, чтобы продолжить в CGTrader AI",
      "loginTitle": "С возвращением",
      "signupSubtitle": "Мы отправим вам 6-значный код на электронную почту, чтобы вы могли войти без создания пароля.",
      "loginSubtitle": "Войдите, чтобы продолжить создавать, проектировать и скачивать."
    },
    "auth": {
      "divider": "или",
      "optIn": "Получайте новости о продуктах, новости сообщества и специальные предложения."
    },
    "email": {
      "label": "Электронная почта",
      "placeholder": "john@email.com",
      "ariaLabel": "Адрес электронной почты"
    },
    "footer": {
      "submit": "Продолжить",
      "haveAccount": "Уже есть аккаунт?",
      "noAccount": "Нет аккаунта?",
      "login": "Войти",
      "signup": "Зарегистрироваться"
    },
    "terms": {
      "prefix": "Продолжая, я соглашаюсь с",
      "termsLink": "Общими условиями и положениями",
      "and": "и",
      "privacyLink": "Политикой конфиденциальности."
    },
    "code": {
      "title": "Проверьте свою почту",
      "subtitlePrefix": "Мы отправили 6-значный код на",
      "yourEmail": "вашу почту",
      "invalidCode": "Неверный код доступа. Попробуйте снова.",
      "resendPrompt": "Не получили письмо?",
      "resendAction": "Нажмите, чтобы отправить снова",
      "digitAriaLabel": "Цифра {{index}}"
    },
    "success": {
      "title": "Вы вошли!",
      "loginSubtitle": "Вы вошли в систему. Продолжайте с того места, где остановились!",
      "signupSubtitle": "Аккаунт создан. Создайте свою первую 3D-модель!"
    },
    "modal": {
      "loginAriaLabel": "Войти в CGTrader AI",
      "signupAriaLabel": "Зарегистрироваться в CGTrader AI",
      "successAriaLabel": "Вы вошли"
    },
    "password": {
      "link": "Войти с паролем",
      "emailLabel": "Email или имя пользователя",
      "title": "Вход с паролем",
      "subtitle": "Введите ваш email и пароль, чтобы продолжить.",
      "passwordLabel": "Пароль",
      "forgotPassword": "Забыли пароль?",
      "submit": "Войти",
      "back": "Назад",
      "showPassword": "Показать пароль",
      "hidePassword": "Скрыть пароль",
      "genericError": "Что-то пошло не так. Пожалуйста, повторите попытку позже.",
      "requiredNotice": "Пожалуйста, также введите пароль, чтобы завершить 2FA.",
      "twoFaTitle": "Введите код подтверждения входа",
      "twoFaDescription": "Код подтверждения отправлен на адрес электронной почты, который вы используете для входа в аккаунт CGTrader",
      "twoFaVerify": "Подтвердить",
      "twoFaCodeLabel": "Код подтверждения"
    }
  },
  "threeDModelPicker": {
    "title": "Выберите или загрузите 3D-модель",
    "purchasesHeading": "Мои покупки",
    "searchPlaceholder": "Поиск 3D-модели",
    "uploadTile": "Загрузить 3D-модель",
    "submit": "Использовать выбранную 3D-модель",
    "error": "Не удалось загрузить купленные модели. Попробуйте снова.",
    "notFound": "Нет купленных моделей по запросу \"{{keywords}}\".",
    "cardLabel": "Выбрать {{title}}",
    "cardUnsupportedLabel": "У {{title}} нет файла, который может открыть просмотрщик",
    "openError": "Не удалось открыть эту 3D-модель. Попробуйте снова.",
    "empty": {
      "title": "У вас пока нет купленных моделей для выбора",
      "description": "Загрузите свою модель или посмотрите каталог.",
      "searchMarketplace": "Найти в каталоге"
    }
  }
}
